// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"73":"f8c2d514","307":"641dc66d"}[chunkId] + ".css";
};